<ng-container [ngSwitch]="currentStep$ | async">
  <myqq-update-flock-presale-alert
    *ngSwitchCase="steps.alert"
    (close)="handleShowEdit($event)"
  ></myqq-update-flock-presale-alert>

  <myqq-dialog-modal
    *ngSwitchCase="steps.edit"
    [useDatumEither]="contextData$ | async"
    [showHeaderDivider]="true"
  >
    <span modal-header> Edit License Plate </span>
    <myqq-loading *onInitial class="fls-1-1">
      <h3>Initializing...</h3>
    </myqq-loading>
    <myqq-loading *onPending class="fls-1-1">
      <h3>Getting data...</h3>
    </myqq-loading>
    <myqq-error
      *onFailure="let errorResponse"
      title="Edit License Plate setup error"
      description="There was a problem getting your vehicles information"
      [error]="errorResponse"
    >
      <footer>
        <button
          myqq-button
          aria-label="refresh"
          id="refresh-button"
          class="save-btn raised"
          color="primary"
          (click)="handleGetData()"
          (keyup.enter)="handleGetData()"
          (keydown.enter)="$event.preventDefault()"
        >
          Refresh
        </button>
      </footer>
    </myqq-error>
    <div
      *onSuccess="let data; let refreshing= refreshing"
      [useDatumEither]="editVehicleIdentifier$ | async"
    >
      <myqq-loading *onPending class="fls-1-1 mwy-4">
        <h3>Editing vehicle...</h3>
      </myqq-loading>
      <myqq-banner
        *ngIf="!!error"
        (dismiss)="handleDismissErrorBanner()"
        message="{{error}}"
        [showContactCustomerSupport]="true"
      >
      </myqq-banner>

      <p class="pwx-5 fw-u1">
        Vehicle {{vehicleCount}} of {{totalPresaleVehicleCount}}
      </p>
      <myqq-vehicle-form
        #editVehicleForm
        [vehicle]="data.flockPresaleVehicles[0]"
      ></myqq-vehicle-form>
      <ng-template #footer>
        <button
          myqq-button
          class="cancel-btn"
          id="cancel"
          (click)="handleCancel()"
          (keyup.enter)="handleCancel()"
          (keydown.enter)="$event.preventDefault()"
        >
          Cancel
        </button>

        <button
          myqq-button
          class="save-btn"
          color="primary"
          [disabled]="!editVehicleForm?.valid || refreshing || (editVehicleIdentifier$ | async | isDatumPending)"
          (click)="handleSubmit(editVehicleForm?.value, data.vehicles, data.flockPresaleVehicles.length)"
          (keyup.enter)="handleSubmit(editVehicleForm?.value, data.vehicles, data.flockPresaleVehicles.length)"
          (keydown.enter)="$event.preventDefault()"
          id="save"
        >
          {{ data.flockPresaleVehicles.length > 1 ? "Next" : "Save" }}
        </button>
      </ng-template>
    </div>
    <div modal-footer class="js-end qq-buttons">
      <ng-container *ngTemplateOutlet="footerTemplate | async"> </ng-container>
    </div>
  </myqq-dialog-modal>
</ng-container>
